// Core Imports
import React, { useEffect } from "react"
import { useTranslation } from "react-i18next"
import SPARK from "spark-core"
import { saveDataToCache, saveDemoData } from "../../components/Researcher/SaveResearcherData"
import locale_lang from "../../locale_map.json"
import Dashboard from "./Dashboard"
// import { useWorker } from "@koale/useworker"

export default function Researcher({ researcher, mode, tab, role, authType, ...props }) {
  const { t, i18n } = useTranslation()
  // const [dataWorker] = useWorker(saveDataToCache)
  // const [demoWorker] = useWorker(saveDemoData)

  const getSelectedLanguage = () => {
    const matched_codes = Object.keys(locale_lang).filter((code) => code.startsWith(navigator.language))
    const lang = matched_codes.length > 0 ? matched_codes[0] : "en-US"
    return i18n.language ? i18n.language : lang ? lang : "en-US"
  }

  useEffect(() => {
    let language = !!localStorage.getItem("SPARK_user_" + researcher.id)
      ? JSON.parse(localStorage.getItem("SPARK_user_" + researcher.id)).language
      : getSelectedLanguage()
      ? getSelectedLanguage()
      : "en-US"
    i18n.changeLanguage(language)
    ;(async () => {
      let sparkAuthId = SPARK.Auth._auth.id
      let sparkAuthPswd = SPARK.Auth._auth.password
      // if (SPARK.Auth._type === "researcher") {
      //   sparkAuthId === "researcher@demo.spark.digital"
      //     ? demoWorker()
      //     : dataWorker(sparkAuthId + ":" + sparkAuthPswd, researcher.id)
      // } else if (SPARK.Auth._type === "admin") {
      //   if (researcher.id) {
      //     dataWorker(sparkAuthId + ":" + sparkAuthPswd, researcher.id)
      //   }
      // }
      if (SPARK.Auth._type === "researcher") {
        sparkAuthId === "researcher@demo.spark.digital" || sparkAuthId === "clinician@demo.spark.digital"
          ? saveDemoData()
          : saveDataToCache(sparkAuthId + ":" + sparkAuthPswd, researcher.id)
      } else if (SPARK.Auth._type === "admin") {
        if (researcher.id) {
          saveDataToCache(sparkAuthId + ":" + sparkAuthPswd, researcher.id)
        }
      }
    })()
  }, [])

  return (
    <React.Fragment>
      <Dashboard researcherId={researcher.id} mode={mode} tab={tab} role={role} authType={authType} />
    </React.Fragment>
  )
}
